import React from 'react';
import { ISeasonProgressStatisticsType } from '../actions/StatsActions';
import SolidGaugeChart, { ISolidGaugeChartDataItem } from './charts/SolidGaugeChart';
import * as am4core from "@amcharts/amcharts4/core";

export interface IUserSeasonsProgressChartsProps {
  data: Array<ISeasonProgressStatisticsType>
}

const UserSeasonsProgressCharts: React.FC<IUserSeasonsProgressChartsProps> = (props: IUserSeasonsProgressChartsProps) => {
    let colors: am4core.Color[] = [
        am4core.color("#7D00F5"),
        am4core.color("#058AE5"),
        am4core.color("#00B593"),
        am4core.color("#8ACC66"),
        am4core.color("#661A2E"),
      ];

    let singlesData: ISolidGaugeChartDataItem[] = [];
    let doublesData: ISolidGaugeChartDataItem[] = [];
    
    if (props.data && props.data.length > 0) {
        singlesData = [
            {
                category: "99+%",
                value: props.data[0].singlesChartsPurpleAwardCount,
                maxValue: props.data[0].totalSinglesChartsCount,
                color: colors[0],
            },
            {
                category: "98+%",
                value: props.data[0].singlesChartsBlueAwardCount,
                maxValue: props.data[0].totalSinglesChartsCount,
                color: colors[1],
            },
            {
                category: "96+%",
                value: props.data[0].singlesChartsGreenAwardCount,
                maxValue: props.data[0].totalSinglesChartsCount,
                color: colors[2],
            },
            {
                category: "90+%",
                value: props.data[0].singlesChartsYellowAwardCount,
                maxValue: props.data[0].totalSinglesChartsCount,
                color: colors[3],
            },
            {
                category: "Passed",
                value: props.data[0].singlesChartsRedAwardCount,
                maxValue: props.data[0].totalSinglesChartsCount,
                color: colors[4],
            },
        ]
    
        doublesData = [
            {
                category: "99+%",
                value: props.data[0].doublesChartsPurpleAwardCount,
                maxValue: props.data[0].totalDoublesChartsCount,
                color: colors[0],
            },
            {
                category: "98+%",
                value: props.data[0].doublesChartsBlueAwardCount,
                maxValue: props.data[0].totalDoublesChartsCount,
                color: colors[1],
            },
            {
                category: "96+%",
                value: props.data[0].doublesChartsGreenAwardCount,
                maxValue: props.data[0].totalDoublesChartsCount,
                color: colors[2],
            },
            {
                category: "90+%",
                value: props.data[0].doublesChartsYellowAwardCount,
                maxValue: props.data[0].totalDoublesChartsCount,
                color: colors[3],
            },
            {
                category: "Passed",
                value: props.data[0].doublesChartsRedAwardCount,
                maxValue: props.data[0].totalDoublesChartsCount,
                color: colors[4],
            },
        ]
    }

    return (
        <div className="UserSeasonsProgressCharts">
            <table className="ProfileChartsTable">
                <tr>
                    <td>Score Completionist View for Season 1 (Singles)</td>
                    <td>Score Completionist View for Season 1 (Doubles)</td>
                </tr>
                <tr>
                    <td><SolidGaugeChart id="Season1SinglesSolidGaugeChart" title="Singles" data={singlesData} /></td>
                    <td><SolidGaugeChart id="Season1DoublesSolidGaugeChart" title="Doubles" data={doublesData} /></td>
                </tr>
            </table>
        </div>
    );
  }
  
  export default UserSeasonsProgressCharts;